import { Component, OnInit, Input, Inject, PLATFORM_ID, ViewChild, ElementRef } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import Swiper from "swiper";
import { Pagination, Autoplay, A11y } from "swiper/modules";
import { isPlatformServer } from "@angular/common";
import { ThemeService } from "../../services/theme.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-hero-internal-slider",
    templateUrl: "./hero-internal-slider.component.html",
})
export class HeroInternalSliderComponent implements OnInit {
    @Input() rendering: ComponentRendering;
    swiper: Swiper;
    _isPlatformServer: boolean = false;
    energySaveMode: boolean;
    energySaveSubscription: Subscription;
    @ViewChild("HeroLandingSwiper", { static: false }) swiperSlider!: ElementRef;

    constructor(@Inject(PLATFORM_ID) public readonly platformId: string, private themeService: ThemeService) {
        platformId;
    }

    ngOnInit() {
      console.log(this.rendering)
      console.log((this.rendering.fields?.Cards as any)?.length)
        this._isPlatformServer = isPlatformServer(this.platformId);
        this.energySaveSubscription = this.themeService.isEnegySaveModeEnabled().subscribe((energySave) => {
            this.energySaveMode = energySave;
        });
    }

    ngAfterViewInit(): void {
        if ((this.rendering.fields as any)?.Cards.length > 1) {
            this.swiper = new Swiper(this.swiperSlider?.nativeElement, {
                slidesPerView: 1,
                freeMode: true,
                centeredSlides: false,
                spaceBetween: 0,
                grabCursor: true,
                autoHeight: false,
                loop: true,
                autoplay:
                    parseFloat((this.rendering.fields?.TimeRotation as any)?.value) && parseFloat((this.rendering.fields?.TimeRotation as any)?.value) > 0
                        ? {
                              delay: parseFloat((this.rendering.fields?.TimeRotation as any)?.value) * 1000,
                          }
                        : false,
                speed: 1200,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                a11y: {
                    enabled: true,
                },
                modules: [Pagination, Autoplay, A11y],
            });
        }
    }
    ngOnDestroy(): void {
        if (!this._isPlatformServer) {
            if (this.energySaveSubscription) {
                this.energySaveSubscription.unsubscribe();
            }
        }
    }
}
